import { type Ripple } from "@dashboard/ripples/types";

export const rippleDraftOrderMetadata: Ripple = {
  type: "improvement",
  ID: "draft-order-metadata-header",
  TTL_seconds: 60 * 60 * 24 * 7,
  dateAdded: new Date(2026, 4, 31),
  content: {
    oneLiner: "Draft order metadata in header",
    contextual: "이 버튼을 클릭하여 초안 주문의 메타데이터를 수정할 수 있습니다.",
    global:
      "초안 주문의 메타데이터를 수정할 수 있는 버튼이 추가되었습니다. 공개 및 비공개 메타데이터를 수정할 수 있습니다.",
  },
};
